import type { AuthorizationFailedResult } from '../types';

export class AuthorizationError extends Error {
    public readonly authorizationResult: AuthorizationFailedResult;

    constructor(result: AuthorizationFailedResult) {
        const unionMissingParts = result.missing.map(({ roles, permissions }) =>
            [
                ...roles.map((role) => `Role.${role}`),
                ...permissions.map((permission) => `'${permission}'`),
            ].join(' AND ')
        );

        const missingMessage =
            unionMissingParts.length == 0
                ? ''
                : `: missing (${unionMissingParts.join(') OR (')})`;

        super(`Authorization exception${missingMessage}`);

        this.authorizationResult = result;
    }
}
